import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  OPCalendarCreateRequestDTO,
  OPCalendarUpdateRequestDTO,
  OPCalendarDeleteRequestDTO,
  OPCalendarReadByTenantIdRequestDTO,
  OPCalendarGetMonthlyCalendarByTenantRequestDTO,
  OPCalendarDTO,
  OPCalendarListDTO,
  OPCalendarGetYearlyWeekendAndHolidayListByTenantRequestDTO,
  OPCalendarGetUpcomingHolidaysRequestDTO,
  OPCalendarGenerateCalendarRequestDTO
} from './calendar.interface';
import {
  OPCalendar_create,
  OPCalendar_update,
  OPCalendar_readAll,
  OPCalendar_delete,
  OPCalendar_readByTenantId,
  OPCalendar_getMonthlyCalendarByTenant,
  OPCalendar_getYearlyWeekendAndHolidayListByTenant,
  OPCalendar_GetUpcomingHolidays,
  OPCalendar_generateCalendar
} from 'src/app/GlobalVariables';

@Injectable({
  providedIn: 'root'
})
export class OPCalendarService {
  constructor(private http: HttpClient) { }

  OPCalendar_readAll(): Observable<OPCalendarListDTO> {
    return this.http.get<OPCalendarListDTO>(OPCalendar_readAll);
  }

  OPCalendar_readByTenantId(data: OPCalendarReadByTenantIdRequestDTO): Observable<OPCalendarListDTO> {
    return this.http.post<OPCalendarListDTO>(OPCalendar_readByTenantId, data);
  }

  OPCalendar_getMonthlyCalendarByTenant(data: OPCalendarGetMonthlyCalendarByTenantRequestDTO): Observable<OPCalendarListDTO> {
    return this.http.post<OPCalendarListDTO>(OPCalendar_getMonthlyCalendarByTenant, data);
  }

  OPCalendar_create(data: OPCalendarCreateRequestDTO): Observable<OPCalendarDTO> {
    return this.http.post<OPCalendarDTO>(OPCalendar_create, data);
  }

  OPCalendar_update(data: OPCalendarUpdateRequestDTO): Observable<OPCalendarDTO> {
    return this.http.post<OPCalendarDTO>(OPCalendar_update, data);
  }

  OPCalendar_delete(data: OPCalendarDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(OPCalendar_delete, data);
  }

  OPCalendar_GetYearlyWeekendAndHolidayListByCompany(data: OPCalendarGetYearlyWeekendAndHolidayListByTenantRequestDTO): Observable<OPCalendarListDTO> {
    return this.http.post<OPCalendarListDTO>(OPCalendar_getYearlyWeekendAndHolidayListByTenant, data);
  }

  OPCalendar_GetUpcomingHolidays(data: OPCalendarGetUpcomingHolidaysRequestDTO): Observable<OPCalendarListDTO> {
    return this.http.post<OPCalendarListDTO>(OPCalendar_GetUpcomingHolidays, data);
  }

  OPCalendar_generateCalendar(data: OPCalendarGenerateCalendarRequestDTO): Observable<void> {
    return this.http.post<void>(OPCalendar_generateCalendar, data);
  }

}
